import { PrepRequestType } from 'models/prep-request.model';
import React, { useState } from 'react';

import RequestStatusTag from 'components/base/request-status-tag';

import { ENUM_REQUEST_STATUS } from 'models/common.model';

const ReviewPrepReport = ({ request }: { request: PrepRequestType }) => {
  const [showDetails, setShowDetails] = useState<boolean[]>([]);

  const toggleDetails = (index: number) => {
    setShowDetails((prev) => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <div className='px-2 md:px-2'>
      {request.items?.map((item, index) => (
        <div key={item.id}>
          <div className='flex flex-col sm:flex-row sm:justify-between border-b border-b-[#EAEBEB] bg-[#F7F7F7E5] px-3 md:px-4 py-4 md:py-4 gap-3 sm:gap-6 items-start sm:items-center'>
            <div className='flex-1'>
              <p className='font-semibold text-[#2E3031] flex items-center capitalize text-sm '>
                {item.ingredient?.name || 'Unknown Item'}
                {request.status === ENUM_REQUEST_STATUS.SENT ||
                request.status === ENUM_REQUEST_STATUS.RECEIVED ? (
                  <span className='ml-4'>
                    <RequestStatusTag status={item.status} />
                  </span>
                ) : null}
              </p>
              {request.status === ENUM_REQUEST_STATUS.SENT ||
              request.status === ENUM_REQUEST_STATUS.RECEIVED ? (
                <div className='flex gap-2 text-sm items-center  text-[#6F7376]'>
                  <h4 className='font-medium text-[#2E3031] capitalize text-sm '>
                    {item.quantity_requested} items requested
                  </h4>
                </div>
              ) : (
                <h3 className='font-medium text-[#6F7376] capitalize text-xs md:text-sm'>
                  {item.quantity_requested} {item.item_type || item.ingredient?.unit_type}
                </h3>
              )}
            </div>

            <div className='flex gap-2 md:gap-3 self-end sm:self-center'>
              {item.prep_item_ingredients && item.prep_item_ingredients.length > 0 && (
                <button
                  className='rounded-full bg-white border px-2 md:px-4 py-1 text-[10px] md:text-xs border-[#EAEBEB]'
                  onClick={() => toggleDetails(index)}>
                  {showDetails[index] ? 'Hide' : 'Show'}
                </button>
              )}
            </div>
          </div>

          {showDetails[index] && item.prep_item_ingredients.length > 0 && (
            <ul className='flex flex-col gap-2 px-3 md:px-2 py-2 bg-white'>
              {item.prep_item_ingredients.map((prepIngredient, itemIndex: number) => (
                <li
                  key={prepIngredient.id}
                  className={`flex flex-wrap items-center gap-2 md:gap-3 py-2 md:py-3 text-xs md:text-sm text-[#2E3031] ${
                    itemIndex < (item.prep_item_ingredients?.length ?? 0) - 1
                      ? 'border-b border-b-[#EAEBEB]'
                      : ''
                  }`}>
                  <span className='font-medium text-[#5E6164]'>
                    {prepIngredient.ingredient?.name || 'Unknown Ingredient'}
                  </span>
                  <span className='w-1 h-1 rounded-full bg-[#D9D9D9]'></span>
                  <span className='text-[#6F7376]'>
                    {prepIngredient.quantity_requested}
                    {' ' + prepIngredient.ingredient?.unit_type || 'units'}
                  </span>
                  {prepIngredient.quantity_wasted > 0 && (
                    <>
                      <span className='w-1 h-1 rounded-full bg-[#D9D9D9]'></span>
                      <span className='text-[#0080E5]'>
                        {prepIngredient.quantity_wasted}
                        {prepIngredient.ingredient?.unit_type || 'units'} wasted
                      </span>
                    </>
                  )}
                  {prepIngredient.excess_quantity > 0 && (
                    <>
                      <span className='w-1 h-1 rounded-full bg-[#D9D9D9]'></span>
                      <span className='text-[#0080E5]'>
                        {prepIngredient.excess_quantity}
                        {prepIngredient.ingredient?.unit_type || 'units'} in excess
                      </span>
                    </>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};

export default ReviewPrepReport;
